const Warning = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="25"
            height="23"
            viewBox="0 0 25 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M20.5293 18.7542C19.0056 14.934 17.0514 11.2859 14.7154 7.90082C14.0528 6.94034 13.3506 5.99119 12.4554 5.2429C12.2862 5.1016 12.0935 4.96115 11.8725 4.95796C11.5028 4.95175 11.2485 5.31441 11.0634 5.63498C8.66372 9.80393 6.26434 13.9726 3.86457 18.1412C3.66115 18.4945 3.47412 18.9868 3.77179 19.265C3.91022 19.3944 4.11146 19.4248 4.29935 19.4481C6.42412 19.713 8.56084 19.8809 10.7008 19.9508C11.0974 19.9641 11.4953 19.9816 11.8855 19.9802C12.0983 20.01 12.3095 20.0271 12.516 20.0313C15.0706 20.0831 17.6344 19.9045 20.1596 19.5189C20.299 19.4976 20.4504 19.4691 20.5416 19.3617C20.6798 19.199 20.6086 18.9525 20.5293 18.7542Z"
                fill="#FDC66E"
            />
            <path
                d="M13.0326 17.6554C12.4937 17.799 11.8237 17.7247 11.3498 18.0427C10.771 18.4306 10.7267 19.3781 11.2271 19.8623C11.7279 20.3469 12.6146 20.3084 13.118 19.8267C13.3257 19.6274 13.4774 19.3521 13.4667 19.0642C13.4561 18.7764 13.2513 18.4891 12.9673 18.4418"
                stroke="#686058"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.6708 16.6747C12.1038 16.6462 10.901 16.6446 10.934 16.6482C10.7273 13.3643 10.6053 10.075 10.5681 6.78467C11.35 6.58149 13.6964 6.64911 13.8203 6.73001C13.9817 6.83545 13.665 14.5425 13.5062 17.0985"
                stroke="#686058"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M0.325755 21.2859C0.486236 21.5411 24.1175 21.7213 24.5907 21.1966C25.064 20.6719 12.5049 1.45898 11.9196 1.45898C11.3341 1.45898 0.140739 20.9915 0.325755 21.2859Z"
                stroke="#686058"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default Warning
